import $ from "jquery";

export default (): void => {
  // this function can be eliminated once the TS QV is refactored
  function galleryInit(e: Event): void {
    const target: EventTarget = (e && e.target) || document;
    const gallerySelections = (<HTMLImageElement>target).querySelectorAll(
      "#galleryAvailable .galleryview"
    );
    const galleryImage: HTMLImageElement = (<HTMLImageElement>(
      target
    )).querySelector("#galleryImage");

    function swapMainImg(e: MouseEvent): void {
      let img = this.querySelector("img");

      e.preventDefault();
      galleryImage.src = img.src;
    }

    gallerySelections.forEach(
      (gview: Element): void => {
        //Prevent adding redundant event listeners
        gview.removeEventListener("click", swapMainImg);
        gview.addEventListener("click", swapMainImg);
      }
    );
  }

  document.addEventListener("DOMContentLoaded", galleryInit);
  document.addEventListener("reconnectpdpviewer", galleryInit);

  // responsive carousel initializer
  function carouselInit(): void {
    let carousel = $("#productCarousel");
    carousel.carousel("dispose");

    // run initializer if test is true
    if (window.innerWidth < 767) carousel.carousel();
  }

  document.addEventListener("DOMContentLoaded", carouselInit);
  window.onresize = carouselInit;

  function checkboxRadio(e: Event): void {
    const target: EventTarget = (e && e.target) || document;
    const radioClass = "input.type-radio";
    const inputs = (<HTMLInputElement>target).querySelectorAll(radioClass);

    function uncheckOthers(): void {
      let _input = this,
        name = _input.name,
        extendName = _input.dataset.extendName;

      if (_input.checked && (name || extendName)) {
        (<HTMLInputElement>target)
          .querySelectorAll(
            radioClass +
              (extendName
                ? ['[data-extend-name="', extendName, '"]']
                : ['[name="', name, '"]']
              ).join("")
          )
          .forEach(
            (input: HTMLInputElement): void => {
              if (input !== _input) {
                input.checked = false;
              }
            }
          );
      }
    }

    inputs.forEach(
      (input): void => {
        //Prevent adding redundant event listeners
        input.removeEventListener("change", uncheckOthers);
        input.addEventListener("change", uncheckOthers);
      }
    );
  }

  document.addEventListener("DOMContentLoaded", checkboxRadio);
  document.addEventListener("reconnectcheckboxradio", checkboxRadio);
};
